import { GrupoEnum } from "@shared/enums/Grupo.enum";

export enum PermisosSidebarEnum {
    NINGUNO = 0,
    INICIO = 1 << 0,
    INVESTIGACIONES = 1 << 1,
    PANELISTAS = 1 << 2,
    CANJES = 1 << 3,
    CUESTIONARIOS = 1 << 4,
    ETIQUETAS = 1 << 5,
    ENHANCED = 1 << 6,
    SAAS = 1 << 7,
    CUOTAS = 1 << 8,
    ATENCION_AL_USUARIO = 1 << 9,
    CONFIGURACION = 1 << 10,
    TODOS = 1 << 10 | 1 << 9 | 1 << 8 | 1 << 7 | 1 << 6 | 1 << 5 | 1 << 4 | 1 << 3 | 1 << 2 | 1 << 1 | 1 << 0
}

const permisos = new Map<GrupoEnum, number>();
permisos.set(GrupoEnum.ADMIN, PermisosSidebarEnum.TODOS);
permisos.set(GrupoEnum.CUSTOMER, PermisosSidebarEnum.INVESTIGACIONES);

export const tienePermisosSidebar = (grupo: GrupoEnum, permiso: PermisosSidebarEnum) => {
    const perm = permisos.get(grupo) ?? 0;
    return (perm & permiso) !== 0;
};
